<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col text-start">
          <vue-excel-xlsx class="btn btn-outline-secondary btn-sm mb-2" v-if="datalists!==null" title="Download to Excel File"
            :data="datalists"
            :columns="columns"
            :filename="'report_ln_status'"
            :sheetname="'sheetname'"
            >
            Download
          </vue-excel-xlsx>
        </div>
      </div>
      <div class="row">
        <div class="col-sm bg-light border py-2">
            <table id="myRepLabStatusTable" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;">
                <thead class="text-dark" style="background:NavajoWhite">
                <tr>
                    <th title="C=Cancel">C</th>
                    <th title="รับชำระเงิน">Paid</th>
                    <th>สถานะ</th>
                    <th>เลขที่ใบตรวจ</th>
                    <th>วันที่</th>
                    <th>ชื่อ-สกุล คนไข้</th>
                    <th>เพศ</th>
                    <th title="แสดงเทสเดียวอาจมีมากกว่านั้น">Test ตรวจ</th>
                    <th>New</th>
                    <th>Lab</th>
                    <th>Resulted</th>
                    <th>AP</th>
                    <th>รอบนำส่ง</th>
                    <th>คำสั่ง</th>
                </tr>
                </thead>
                <tbody>
                <!-- <tr v-for="item in datalists" :key="item.itemtestid" v-bind:data-id="item.ItemTestID"  @click="tableChanged(item)"> -->
                <tr v-for="item in datalists" :key="item.ROID">
                    <td class="text-danger">{{ arrCancel[item.Cancel] }}</td>
                    <td class="">{{ arrPaid[item.Paid] }}</td>
                    <td class="">{{ arrDocStatus[item.Status] }}</td>
                    <td class="text-start">{{ item.RONo }}</td>
                    <td class="text-start">{{ item.DocDate }}</td>
                    <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="">{{ arrSex[item.Sex] }}</td>
                    <td class="text-start">{{ item.Test }}</td>
                    <td class="text-center" style="background-color: HoneyDew;">{{ item.DocDate }} {{item.DocTime}} ({{ item.UserName1 }} )</td>
                    <td class="text-center" style="background-color: HoneyDew;">{{ item.ReceivedDateStr }} ({{item.UserNameRcvlab}} )</td>
                    <td class="text-center" style="background-color: HoneyDew;">{{ item.ResultedDateStr }} ({{ item.UserName2 }} )</td>
                    <td class="text-center" style="background-color: HoneyDew;">{{ item.ApprovedDateStr }} ({{ item.UserName3 }} )</td>
                    <td class="text-center">{{ item.ReceivedRound }}</td>
                    <td class="text-end">
                        <button type="button" class="btn btn-outline-info btn-sm mx-1"
                          id="View" @click="viewRecord(item)" title="แสดงรายละเอียด">View</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'RepLabStatus',
  components: {

  },
  data () {
    return {
      columns: [
        { label: 'สถานะ', field: 'Status' },
        { label: 'เลขที่ใบตรวจ', field: 'RONo' },
        { label: 'วันที่', field: 'DocDate' },
        { label: 'เวลา', field: 'DocTime' },
        { label: 'คำนำหน้า', field: 'PrefixName' },
        { label: 'ชื่อ', field: 'PatName' },
        { label: 'นามสกุล', field: 'PatLName' },
        { label: 'เพศ', field: 'Sex' },
        { label: 'ชุดตรวจ', field: 'Test' }
      ],
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      arrCancel: ['', 'C'],
      arrPaid: ['', 'Paid'],

      curRecord: {}
    }
  },
  props: ['datalists'],
  created () {

  },
  mounted () {

  },
  methods: {
    viewRecord (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      // this.action = 'view'
      this.$emit('onViewRecordEvent', this.curRecord)
    }
  }
}
</script>

<style>
.bg-lightblue {
  background-color: aliceblue;
}
</style>
